import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    minWidth: 440,
    maxWidth: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
  },
  text: {
    fontSize: 16,
    color: theme.palette.text.primary,
  },
  pegueText: {
    fontSize: 14,
    color: theme.palette.primary.main,
    textAlign: "center",
    marginTop: theme.spacing(1),
  },
  divider: {
    backgroundColor: "#eee",
    height: 2,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
